import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import NewDocumentModal from './partials/NewDocumentModal'
import DocumentsTable from './partials/DocumentsTable'

import { handleError, parsePagination } from '../../helpers'
import { getDocuments } from './services'

export default function DocumentsList() {
	const [documents, setDocuments] = useState(null)
	const [filterType, setFilterType] = useState('title')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [showNewModal, setShowNewModal] = useState(false)

	useEffect(() => {
		!documents && getDocuments({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			include: 'categories',
			sort: '-created_at',
		})
			.then(res => {
				setDocuments(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ documents, pagination, filterType, filterValue ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Documentos Descargables"
				subtitle="Listado de todos los documentos descargables"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setDocuments(null)}
				options={[
					{ label: 'Buscar por titulo', value: 'title' },
					{ label: 'Buscar en palabras clave', value: 'keywords' },
				]}
				ctaText="Agregar Documento"
				handleCtaClick={() => setShowNewModal(true)}
			/>
			<Card>
				<CardBody>
					<DocumentsTable 
						documents={documents}
						reload={() => setDocuments(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
			{ showNewModal && (
				<NewDocumentModal 
					visible
					onClose={() => setShowNewModal(false)}
					reload={() => {
						setDocuments(null)
						setShowNewModal(false)
					}}
				/>
			)}
		</React.Fragment>
	)
}